import React from 'react';
import './App.css';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './ScrollToTop'; // ✅ import it


import Home from './Home';
import About from './About';
import Services from './Services';
import Media from './Media';
import Contact from './Contact';
import Navbar from './Navbar';
import Footer from './Footer';
import Staff from './Staff'; // ✅ Make sure the path is correct
import Blog from './Blog';
import Reception from './Reception'; // Adjust path as necessary
import CounselingRoom1 from './CounselingRoom1';
import CounselingRoom2 from './CounselingRoom2';
import ConsultationRoom from './ConsultationRoom';
import Laboratory from './Laboratory';
import BrandIdentity from './BrandIdentity';
import Faqs from './Faqs'; // 👈 Import your FAQ page

function App() {
  return (
    <Router>
      <ScrollToTop /> {/* ✅ include it here */}
      <Navbar />
      <div className="container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/media" element={<Media />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/our-staff" element={<Staff />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/brand-identity" element={<BrandIdentity />} /> {/* 👈 Your new route */}
          <Route path="/faqs" element={<Faqs />} /> {/* 👈 FAQ route */}
          <Route path="/facilities/reception" element={<Reception />} />
          <Route path="/facilities/counselling-room-1" element={<CounselingRoom1 />} />
          <Route path="/facilities/counselling-room-2" element={<CounselingRoom2 />} />
          <Route path="/facilities/consultation-room" element={<ConsultationRoom />} />
          <Route path="/facilities/lab" element={<Laboratory />} />
        </Routes>
      </div>
      <Footer /> {/* ✅ ADD THIS LINE */}
    </Router>
  );
}

export default App;
